module.exports = __webpack_public_path__ + "static/media/fresno-logo.09261771.png";